import { NavLink } from 'react-router-dom';
export function NotFoundPage(){ return <div className="center-screen"><div><h1>404</h1><p>Cette page n’existe pas.</p><NavLink className="button primary" to="/">Retour à EDUVERSA</NavLink></div></div>; }
